/**
 * Reports (البلاغات) Service
 * Follows the same pattern as services/support/support.js
 */

import axios from "axios";
import API from "../../api/api";
import { BASE_URL, DEFAULT_KEY } from "../../config/config";

const callApi = async (endpoint) => {
    try {
        const response = await API.get(endpoint);
        return response?.data?.data;
    } catch (error) {
        console.log(error);
        throw error;
    }
};

export const ReportServices = {
    // ------------------------------------------------------------------
    // GET list of my reports (paginated + filtered)
    // ------------------------------------------------------------------
    getReports: async (page, itemsPerPage, category, status, trackId) => {
        return await callApi(
            `/reports?trackId=${trackId}&category=${category}&status=${status}&page=${page}&perPage=${itemsPerPage}`
        );
    },

    // ------------------------------------------------------------------
    // GET categories & statuses for filter selects
    // ------------------------------------------------------------------
    getReportPartials: async () => {
        return await callApi("/report-partials");
    },

    // ------------------------------------------------------------------
    // GET autocomplete user search (no downline restriction)
    // ------------------------------------------------------------------
    searchUsers: async (q, limit = 10) => {
        return await callApi(`/report-user-search?q=${encodeURIComponent(q)}&limit=${limit}`);
    },

    // ------------------------------------------------------------------
    // POST create report (multipart/form-data)
    // ------------------------------------------------------------------
    createReport: async (data) => {
        const formData = new FormData();

        if (data.attachment && data.attachment.length > 0) {
            [...data.attachment].forEach((file) => {
                formData.append("file", file);
            });
        }

        formData.append("reportedUserId", data.reportedUserId);
        formData.append("category",       data.category);
        formData.append("subject",        data.subject);
        formData.append("description",    data.description);

        const customAxios = axios.create({
            baseURL:          BASE_URL,
            withCredentials:  true,
        });
        customAxios.defaults.headers.common["api-key"]       = localStorage.getItem("api-key") || DEFAULT_KEY;
        customAxios.defaults.headers.common["Content-Type"]  = "multipart/form-data";

        try {
            const response = await customAxios.post("report", formData);
            return response.data;
        } catch (error) {
            return error?.response?.data;
        }
    },

    // ------------------------------------------------------------------
    // GET single report details
    // ------------------------------------------------------------------
    getReportDetails: async (trackId) => {
        return await callApi(`/report-details/${trackId}`);
    },
};
